







import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';

@Component({
  components: {
  },
})
export default class MswBuildcheck extends SwExtendedVue {
}
